/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/token';
import '../../common/user_attributes';
import './status';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "message": {
                    "nested": {
                      "ActivateExperimentRequest": {
                        "fields": {
                          "experimentName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "variantName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 3,
                            "rule": "optional"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 4,
                            "rule": "optional"
                          },
                          "projectId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "cdpKey": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "ActivateExperimentResponse": {
                        "fields": {
                          "status": {
                            "type": "squareup.feature.relay.experiments.message.Status",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE ActivateExperimentRequest @ squareup/feature/relay/experiments/message/activate_experiment.proto at 13:1
 */
export const ActivateExperimentRequest = $root.lookupType('squareup.feature.relay.experiments.message.ActivateExperimentRequest');
fixType(ActivateExperimentRequest, {
  experimentName: {
    required: true,
    notEmpty: true
  },
  variantName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  }
});
Builder.createAndAttachToType(ActivateExperimentRequest);
/**
 * SOURCE ActivateExperimentResponse @ squareup/feature/relay/experiments/message/activate_experiment.proto at 28:1
 */
export const ActivateExperimentResponse = $root.lookupType('squareup.feature.relay.experiments.message.ActivateExperimentResponse');
fixType(ActivateExperimentResponse);
Builder.createAndAttachToType(ActivateExperimentResponse);